import baseApi from ".";
import createQueryFn from "../createQueryFn";
import api from "api";
import { CreateOfficeRequest, CreateOfficeResponse } from "api/offices/createOffice";
import { DeleteOfficeRequest, DeleteOfficeResponse } from "api/offices/deleteOffice";
import { GetAllOfficesResponse } from "api/offices/getAll";
import { UpdateOfficeRequest, UpdateOfficeResponse } from "api/offices/updateOffice";

const officesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createOffice: builder.mutation<CreateOfficeResponse, CreateOfficeRequest>({
      queryFn: createQueryFn(api.offices.createOffice),
      invalidatesTags: [{ type: "Office", id: "LIST" }],
    }),
    deleteOffice: builder.mutation<DeleteOfficeResponse, DeleteOfficeRequest>({
      queryFn: createQueryFn(api.offices.deleteOffice),
      invalidatesTags: [{ type: "Office", id: "LIST" }],
    }),
    getAllOffices: builder.query<GetAllOfficesResponse, void>({
      queryFn: createQueryFn(api.offices.getAllOffices),
      providesTags: [{ type: "Office", id: "LIST" }],
    }),
    updateOffice: builder.mutation<UpdateOfficeResponse, UpdateOfficeRequest>({
      queryFn: createQueryFn(api.offices.updateOffice),
      invalidatesTags: [{ type: "Office", id: "LIST" }],
    }),
  }),
});

export const {
  useCreateOfficeMutation,
  useDeleteOfficeMutation,
  useGetAllOfficesQuery,
  useUpdateOfficeMutation,
} = officesApi;

export default officesApi;
